import { type SuretyAccountId } from "@inrev/common";
import { useAdminFetchLatestSuretyAccountUnderwriting } from "@portal/api/account/admin";
import { Card } from "@portal/components/primitives";
import { CenteredSpinner } from "@portal/components/ui/CenteredSpinner";
import { FC } from "react";
import type { AccountIdentity } from "../../../../shared/account/AccountHeader";
import { AdminReviewReasonList } from "../../../../shared/admin/AdminReviewReasonList";
import { BondingLinesMatrix } from "./bonding-lines/BondingLinesMatrix";

export type AdminAccountReviewAndBondingLinesProps = {
	account?: AccountIdentity;
};

const AdminAccountReviewReasons = ({ accountId }: { accountId: SuretyAccountId }) => {
	const { latestUnderwriting } = useAdminFetchLatestSuretyAccountUnderwriting(accountId);
	if (!latestUnderwriting) return null;
	return <AdminReviewReasonList reviewReasons={latestUnderwriting.reviewReasons} />;
};

export const AdminAccountReviewAndBondingLines: FC<AdminAccountReviewAndBondingLinesProps> = ({
	account,
}) => {
	if (!account) return <CenteredSpinner />;

	return (
		<div className="flex flex-col space-y-[40px]">
			<AdminAccountReviewReasons accountId={account.id} />
			<Card
				elevation="raised"
				className="rounded-xl"
				data-testid="admin-account-bonding-lines-card"
			>
				<Card.Body className="p-6">
					<BondingLinesMatrix account={account} hideReviewReasons />
				</Card.Body>
			</Card>
		</div>
	);
};
